import { RiskAndInvestmentPreferencesFields } from 'src/non-financial-data/v2/sections/fields/RiskAndInvestmentPreferencesFields';
import IndividualEntityForm from '../IndividualEntityForm';

export default function RiskAndInvestmentPreferencesV2() {
  return (
    <IndividualEntityForm title="Risk & investment preferences">
      <RiskAndInvestmentPreferencesFields />
    </IndividualEntityForm>
  );
}
